
import * as properties from './properties'

/**
 * Style sheet.
 */

const styles = newStyleTag().sheet
const cache = new Map

/**
 * getStyleProperties returns an array with the
 * style properties separated from the rest.
 */

export function getStyleProperties(props) {
  const keys = Object.keys(props)
  const style = {}
  const rest = {}

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    if (properties[k]) {
      style[k] = props[k]
    } else {
      rest[k] = props[k]
    }
  }

  return [style, rest]
}

/**
 * getClassname returns a classname for css computed from props,
 * with an optional prefix name to help distinguish the element
 * from others.
 */

export function getClassname({ displayName, ...props }, hash) {
  const [style, rest] = getStyleProperties(props)
  const keys = Object.keys(style)
  let rule = ''

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    const v = style[k]
    const p = properties[k]
    rule += applyProperty(p, v)
  }

  rule += cssProperty('-webkit-appearance', 'none')
  rule += cssProperty('box-sizing', 'border-box')

  const className = classname(hash, rule, displayName)

  if (!cache.get(className)) {
    styles.insertRule(`.${className} { ${rule} }`)
    cache.set(className, true)
  }

  rest.className = className
  return rest
}


/**
 * applyCustomProperties returns props with custom
 * property definitions applied, which are functions
 * taking a value and returning an object of css properties.
 */

export function applyCustomProperties(props, custom = {}) {
  const keys = Object.keys(props)
  const o = {}

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    const c = custom[k]
    const v = props[k]

    if (!c) {
      o[k] = v
      continue
    }

    const p = c(v)
    for (let k in p) {
      o[k] = p[k]
    }
  }

  return o
}


/**
 * classname returns a classname for a rule with optional prefix.
 */

function classname(hash, rule, prefix) {
  return prefix
    ? `☐-${prefix}-${hash(rule)}`
    : `☐-${hash(rule)}`
}

/**
 * applyProperty returns the css property for a property and value.
 */

function applyProperty(p, v) {
  // default value
  if (v === true && p.default != null) {
    v = p.default
  }

  // formatter
  if (p.format) {
    v = p.format(v)
  }
  
  // single property
  return cssProperty(p.name, v, p.unit)
}

/**
 * cssProperty returns a formated css property.
 */

function cssProperty(k, v, unit = 'px') {
  return `${k}: ${cssValue(v, unit)};`
}

/**
 * cssValue returns the css value as a string, with optional numeric unit.
 */

function cssValue(v, unit) {
  return typeof v == 'number'
    ? v + unit
    : v
}

/**
 * newStyleTag returns a new style tag which is injected into head.
 */

function newStyleTag() {
  const tag = document.createElement('style')
  tag.type = 'text/css'
  tag.setAttribute('data-box', '')
  tag.append(document.createTextNode(''))
  const head = document.head || document.querySelector('head')
  head.append(tag)
  return tag
}